export const getUserAge = (userBirthDate: Date) => {
  if (!Date.parse(userBirthDate.toDateString())) {
    return 0;
  }
  const currentDate = new Date();
  return Math.abs(
    new Date(currentDate.getTime() - userBirthDate.getTime()).getUTCFullYear() -
      1970
  );
};
